import { render } from "./Gamelist.vue?vue&type=template&id=95915c76"
import script from "./Gamelist.vue?vue&type=script&lang=js"
export * from "./Gamelist.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\hongy-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__